function Organization() {}

export default Organization;
